import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import {
  BASE_WIDTH_FOR_ASPECT_RATIO,
  DEFAULT_WIDGET_OPTIONS,
  getBannerImages,
  getHeight,
} from '../../utils';
import { useSSRSelector } from 'src/redux';
import { BannerItem } from '../BannerItem';
import { ADMIN_WIDGETS_NAMES, OLD_WIDGET_NAMES } from 'src/constants/widgets';

export default function IntermittentBanner(props) {
  const widgets = useSSRSelector((state) => state.jsonWidgetsReducer.widgets);
  const storeData = useSSRSelector((state) => state.storeReducer.store);
  const { isMobile } = useGetDeviceType();
  let widgetOptions = props.widgetOptions;

  /**  When this intermittent banner is used as loader, nothing can be passed as props, thus this was used
   * The issue if arises in future will be if both Carousel & NewHeroBanner are present in a store together,
   *  */
  if (!props.widgetOptions) {
    widgetOptions = (
      Object.values(widgets || {}).find((widget: any) =>
        [OLD_WIDGET_NAMES.CAROUSEL, ADMIN_WIDGETS_NAMES.HERO_BANNER].includes(widget.name)
      ) as any
    )?.props || { ...DEFAULT_WIDGET_OPTIONS };
  }

  const images = getBannerImages({
    props: { store: storeData, widgetOptions },
    activeWidgetProps: null,
    isDesktop: !isMobile,
  });

  const isNewCarousel = widgetOptions?.forNewCarousel;
  const heightFromProps = widgetOptions?.[isMobile ? 'heightMobile' : 'height'];
  const useOriginalHeight = heightFromProps === 'original';

  const height = (() => {
    if (useOriginalHeight) return 'auto';

    // This removed px unit because we need to calculate aspect ratio by using configured height unit, with fixed width unit
    if (isNewCarousel) {
      return heightFromProps?.includes?.('px')
        ? heightFromProps?.split('px')[0]
        : heightFromProps;
    }

    return getHeight(
      widgetOptions,
      props?.containerRef?.current?.clientWidth,
      isNewCarousel,
      isMobile
    );
  })();

  const imageToShow = images[0];

  useEffect(() => {
    if (props.setLoadSlider) {
      const timeoutID = setTimeout(() => {
        props.setLoadSlider(true);
      }, 3100);

      return () => {
        clearTimeout(timeoutID);
      };
    }
  }, []);

  if (!imageToShow) return null;
  return (
    <div
      className={classNames(`tw-relative tw-bg-opacity-20`)}
      ref={props.containerRefCallback}
      style={
        isNewCarousel && {
          marginTop:
            widgetOptions?.marginTop + props.adjustedMarginByAnnouncement || '0px',
          marginBottom: widgetOptions?.marginBottom || '0px',
          ...(widgetOptions?.isBannerFullWidth === false
            ? {
                marginLeft: isMobile ? '16px' : '80px',
                marginRight: isMobile ? '16px' : '80px',
              }
            : {}),
        }
      }
    >
      <BannerItem
        image={imageToShow}
        isCurrentSlideActive={true}
        isNewCarousel={isNewCarousel}
        widgetOptions={widgetOptions}
        imageWrapperComponentStyles={
          isNewCarousel && !useOriginalHeight
            ? {
                aspectRatio: `${BASE_WIDTH_FOR_ASPECT_RATIO[isMobile ? 'mobile' : 'desktop']}/${height}`,
              }
            : {
                height: height,
                width: props?.containerRef?.current?.clientWidth
                  ? `${props?.containerRef?.current?.clientWidth}px`
                  : '100vw',
              }
        }
        isMobile={isMobile}
        useDefaultHTMLTag={useOriginalHeight}
      />
    </div>
  );
}
